module.exports = __webpack_public_path__ + "static/our-firm-1-66daefed6a29f929176084437fbaba9b.jpg";